import { Injectable } from "@angular/core";

@Injectable()
export class LocalStorageService {
    // we store some items in localStorage, but we should not rely on these
    // most of the items should be in session storage, to get rid of them in the end
    localStorageKeys: string[] = [];

    constructor() {
        // items that are stored in localStorage
        this.localStorageKeys.push("temp-confirmation");
        this.localStorageKeys.push("temp-insurance-confirmation");
        this.localStorageKeys.push("temp-user");
        this.localStorageKeys.push("temp-token");
        this.localStorageKeys.push("temp-tokenExpireDate");
    }

    add(key: string, value: string) {
        if (this.localStorageKeys.indexOf(key) > -1) {
            localStorage.setItem(key, value);
        } else {
            sessionStorage.setItem(key, value);
        }
    }

    remove(key) {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    }

    get(key): string {
        if (this.localStorageKeys.indexOf(key) > -1) {
            return localStorage.getItem(key);
        } else {
            return sessionStorage.getItem(key);
        }
    }

    clear() {
        sessionStorage.clear();
        let keys = Object.keys(localStorage)
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] != "lastSearch" && keys[i] != "lastSearchResults") {
                localStorage.removeItem(keys[i])
            }
        }
    }

    keys(): string[] {
        return Object.keys(sessionStorage);
    }

    cloneAsObject(): any {
        return Object.keys(sessionStorage).reduce((obj, str) => {
            obj[str] = sessionStorage.getItem(str);
            return obj;
        }, {});
    }
}



// WEBPACK FOOTER //
// ./src/services/storage/localStorage.service.ts